import React from "react";
import { motion } from "framer-motion";
import { FiCheckCircle } from "react-icons/fi";
import SectionHeading from "../../components/SectionHeading";
import CertificationLogos from "../../components/CertificationLogos";
import { benefitsLabel, servicesContent } from "./isoContent";

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: "easeOut" } },
};

/* One card per standard, each led by that standard's real certification mark
   from the shared registry — the same marks the Services page uses. Every one
   of the six has a file, so no fallback is reached here. */
const IsoStandards = () => (
  <section
    className="bg-gray-50 py-14 lg:py-20"
    aria-labelledby="iso-standards-heading"
  >
    <div className="brand-col">
      <SectionHeading
        id="iso-standards-heading"
        title={servicesContent.title}
      />
      <motion.ul
        className="grid list-none grid-cols-1 gap-6 p-0 lg:grid-cols-2 lg:gap-8"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.05 }}
        variants={{ visible: { transition: { staggerChildren: 0.07 } } }}
      >
        {servicesContent.standards.map((standard) => (
          <motion.li
            key={standard.id}
            id={standard.id}
            variants={cardVariants}
            className="brand-card scroll-mt-24 p-6 lg:p-8"
          >
            <CertificationLogos
              logoKeys={[standard.logoKey]}
              label={`${standard.title} certification mark`}
              className="flex h-[4.5rem] items-center"
              size="h-[4.5rem]"
            />

            <h3 className="mt-4 text-lg lg:text-xl font-bold text-gray-900">
              {standard.title}
            </h3>
            <p className="mt-1 text-sm md:text-base font-semibold text-[var(--brand-primary)]">
              {standard.subtitle}
            </p>

            <div className="mt-4 space-y-3">
              {standard.paragraphs.map((paragraph) => (
                <p
                  key={paragraph}
                  className="text-sm md:text-base leading-relaxed text-gray-600"
                >
                  {paragraph}
                </p>
              ))}
            </div>

            <p className="mt-5 text-sm font-semibold text-gray-900">
              {benefitsLabel}
            </p>
            <ul className="mt-3 grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2">
              {standard.benefits.map((benefit) => (
                <li key={benefit} className="flex items-start gap-3">
                  <FiCheckCircle
                    aria-hidden="true"
                    size={18}
                    className="mt-0.5 flex-shrink-0 text-[var(--brand-primary)]"
                  />
                  <span className="text-sm md:text-base text-gray-700">
                    {benefit}
                  </span>
                </li>
              ))}
            </ul>
          </motion.li>
        ))}
      </motion.ul>
    </div>
  </section>
);

export default IsoStandards;
